import { render, staticRenderFns } from "./AvailableVariantsTable.vue?vue&type=template&id=8d01fbf4&scoped=true"
import script from "./AvailableVariantsTable.vue?vue&type=script&lang=js"
export * from "./AvailableVariantsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d01fbf4",
  null
  
)

export default component.exports